module.exports = __webpack_public_path__ + "static/template-about-history-background-a46ef39902e23ffd432e0af05d462447.jpg";